export const environment = {
  /**
   * マップの切り替え.
   *
   * - none : マップ使用しない
   * - osm : OpenStreetMap
   * - google : Google Map
   *    `index.html` に `<script src="https://maps.googleapis.com/maps/api/js?key=${GoogleMapApikey}" async defer></script>` を指定してください。
   */
  map: 'google',
  servicerApiUrl: 'https://streamer.nissan-mslab.com/vehicle',
  servicerApiUrls: [
    'https://streamer.nissan-mslab.com/vehicle',
    'http://localhost:8081',
    'https://streamer.nissan-mslab.com/vehicle',
    'https://dev.streamer.nissan-mslab.com/vehicle'
  ],
  /** 環境プロファイル
   *
   * profiles: ビルド環境の情報を定義する
   */
  profiles: [
    {
      name: 'dev-hub',
      label: '開発Develop',
      url: 'nissan-mslab-dev-na.com/dashboard-develop'
    },
    {
      name: 'dev-spoke',
      label: '開発SPOKE',
      url: 'nissan-mslab-dev-na.com/dashboard'
    },
    {
      name: 'prod-hub',
      label: '本番Develop',
      url: 'nissan-mslab-productionserver.com/dashboard-develop'
    },
    {
      name: 'prod-spoke',
      label: '本番SPOKE',
      url: 'nissan-mslab-productionserver.com/dashboard'
    },
  ],

  /**
     * CSV取得先URL.
     *
     * - 本番リリース時 :
     */
  stationCsvUrl: 'https://streamer.nissan-mslab.com/reserve/v2/image?name=stop_point/data.csv',
  loginUserCsvUrl: 'https://streamer.nissan-mslab.com/reserve/v2/image?name=dashboard/account/loginUser.csv',
  /**
   * タイトル.
   *
   * - 浪江/NATC(浪江同等) : Namie Mobility Service
   * - シャドーFMS/横浜 : Nissan Mobility Service
   */
  title: 'main-prd-namie-shift',
  /**
   * [システム]ダッシュボードAPIを取得する間隔（単位：ms）.
   * FMS/CMS の一覧を表示する間隔に影響する.
   *
   * - 浪江/NATC(浪江同等) : 10000
   * - シャドーFMS/横浜 : 1000
   */
  systemDashboardInterval: 10000,
  /**
   * [システム] [休憩計画]ダッシュボードAPIを取得する間隔（単位：ms）.
   */
  systemRestPlanDashboardInterval: 10000,
  /**
   * [休憩計画] 需要の評価の色を変えるための値.
   */
  restPlanDemandCount: 10,
  /**
   * appMonitorAPIを取得する間隔(単位:ms)
   */
  appMonitorInterval: 10000,

  /**
   * FMS画面の環境変数
   */
  fms: {

    /** 言語 */
    language: 'ja',

    /** 間隔 */
    intervals: {

      /** ダッシュボード情報取得（sec） */
      dashboard: 10,

      /** アラート情報取得（sec） */
      alert: 10,

      /** 監視情報取得（sec） */
      monitor: 10
    }
  },

  /**
   * HOME画面の環境変数
   */
  home: {

    /** 言語 */
    language: 'ja',

    /** 間隔 */
    intervals: {

      /** ダッシュボード情報取得（sec） */
      dashboard: 5,

    }
  },

  /**
  * 休憩計画画面の環境変数
  */
  restPlan: {

    /** 間隔 */
    intervals: {

      /** ダッシュボード情報取得（sec） */
      dashboard: 10,

    }
  },

  /**
   * map画面の環境変数
   */
  wholeMap: {

    /** 言語 */
    language: 'ja',

    /** 間隔 */
    intervals: {

      /** ダッシュボード情報取得（sec） */
      dashboard: 5,

      /** 監視情報取得（sec） */
      monitor: 10
    }
  },
  /**
   * 料金システム画面の環境変数
   */
  chargeSystem: {

    /** 間隔 */
    intervals: {

      /** 配車予約一覧情報取得（sec） */
      timeTables: 10
    }
  },
  /**
   * CMS画面の環境変数
   */
  cms: {
    /** 間隔 */
    intervals: {

      /** ダッシュボード情報取得（sec） */
      dashboard: 10,

      /** 監視情報取得（sec） */
      monitor: 10,

      /** ダッシュボード情報取得（sec） */
      dashboardUsers: 3600
    }
  },
  /**
   * エリアインデックス.
   *
   * - 浪江/NATC(浪江同等) : 1
   * - シャドーFMS/横浜 : 2
   */
  areaIndex: 1,
  /** エリアリスト. */
  areas: [
    {
      name: 'NATC',
      areaId: 1,
      /** HUBのエリアID. */
      hubAreaId: 1,
      /** SPOKEのエリアID. */
      spokeAreaId: 2,
      /** マップ初期緯度. */
      lat: 35.445849800,
      /** マップ初期経度. */
      lon: 139.313523200,
      /** マップ初期ズーム. */
      zoom: 18,
      /** CMSに表示するユーザのログインID（正規表現）. */
      userPattern: '^U([0-9]*[0-9][0-9][0-9])$',
      /** FMS 表示車両情報. */
      fmsVehicles: [
        {
          /**
           * カテゴリ.
           * title：タイトル
           * activeVehicleEnabled：稼働中車両有無（稼働中車両と座席占有状況の件数に該当する車両）
           */
          category: {
            title: '自動運転 Easy Ride（中心部）',
            activeVehicleEnabled: false
          },
          /**
           * 表示車両一覧.
           * vin：VIN番号
           * img：車両画像
           * controlEnabled：車両制御ボタン（サービスOFF、リクエストキャンセル、待機場所ボタン）の活性有無.
           */
          vehicles: [
            { vin: 'YVN792', img: 'assets/img/fms/car/car04.png', controlEnabled: true },
            { vin: 'YVN793', img: 'assets/img/fms/car/car04.png', controlEnabled: true }
          ]
        },
        {
          category: {
            title: '有人シャトル（中心部）',
            activeVehicleEnabled: true
          },
          vehicles: [
            { vin: 'eNV001', img: 'assets/img/fms/car/car03.png', controlEnabled: true },
            { vin: 'eNV002', img: 'assets/img/fms/car/car03.png', controlEnabled: true }
          ]
        },
        {
          category: {
            title: 'EVタクシー（周辺部）',
            activeVehicleEnabled: true
          },
          vehicles: [
            { vin: 'ZE0001', img: 'assets/img/fms/car/car01.png', controlEnabled: true },
            { vin: 'ZE1001', img: 'assets/img/fms/car/car02.png', controlEnabled: true },
            { vin: 'ZE1002', img: 'assets/img/fms/car/car02.png', controlEnabled: true }
          ]
        }
      ],
      /** ポリライン. */
      basePolylines: []
    },
    {
      name: '浪江',
      areaId: 3,
      hubAreaId: 3,
      spokeAreaId: 4,
      lat: 37.494338100,
      lon: 141.000402000,
      zoom: 15,
      userPattern: '^(U|G)([0-9]*[0-9][0-9][0-9])$',
      fmsVehicles: [
        {
          category: {
            title: '有人シャトル（中心部）',
            activeVehicleEnabled: true
          },
          vehicles: [
            { vin: 'NV01', img: 'assets/img/fms/car/NV350_01_291x200.png', controlEnabled: true },
            { vin: 'NV02', img: 'assets/img/fms/car/NV350_02_291x200.png', controlEnabled: true },
            { vin: 'NV03', img: 'assets/img/fms/car/NV350_03_291x200.png', controlEnabled: true },
            { vin: 'eNV05', img: 'assets/img/fms/car/eNV200_05_291x200.png', controlEnabled: true }
          ]
        }
      ],
      basePolylines: []
    },
    {
      name: '横浜',
      areaId: 5,
      hubAreaId: null,
      spokeAreaId: 5,
      lat: 35.450939000,
      lon: 139.638361000,
      zoom: 15,
      userPattern: '^(U|N)([0-9]*[0-9][0-9][0-9])$',
      fmsVehicles: [
        {
          category: {
            title: 'MSPF車両',
            activeVehicleEnabled: true
          },
          vehicles: [
            { vin: 'SHADOW001', img: 'assets/img/fms/car/leaf.png', controlEnabled: true },
            { vin: 'SHADOW002', img: 'assets/img/fms/car/leaf.png', controlEnabled: true },
            { vin: 'SHADOW003', img: 'assets/img/fms/car/leaf.png', controlEnabled: true },
            { vin: 'SHADOW004', img: 'assets/img/fms/car/leaf.png', controlEnabled: true }
          ]
        },
        {
          category: {
            title: '自動運転 Easy Ride',
            activeVehicleEnabled: false
          },
          vehicles: [
            { vin: 'YVN792', img: 'assets/img/fms/car/car04.png', controlEnabled: false },
            { vin: 'YVN793', img: 'assets/img/fms/car/car04.png', controlEnabled: false },
            { vin: 'YVN808', img: 'assets/img/fms/car/car04.png', controlEnabled: false },
            { vin: 'YVN809', img: 'assets/img/fms/car/car04.png', controlEnabled: false }
          ]
        }
      ],
      basePolylines: []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts